var React = require('react');

function FacebookIconInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m12 2c-5.5 0-10 4.49-10 10.02 0 5 3.66 9.15 8.44 9.9v-7h-2.54v-2.9h2.54v-2.21c0-2.51 1.49-3.89 3.78-3.89 1.09 0 2.23.19 2.23.19v2.47h-1.26c-1.24 0-1.63.77-1.63 1.56v1.88h2.78l-.45 2.9h-2.33v7h-.001c4.86-.77 8.45-4.98 8.4400208-9.9 0-5.53-4.5000208-10.02-10.0000208-10.02z"}));
}

FacebookIconInline.defaultProps = {"height":"24","viewBox":"0 0 24 24","width":"24"};

module.exports = FacebookIconInline;

FacebookIconInline.default = FacebookIconInline;
